module.exports = __webpack_public_path__ + "static/04-06dce052b93c764caa947d06efd8f3e1.jpg";